import getFooterNavigationExtension from './ws-footer-navigation';
import getSocialLinksExtension from './ws-social-links';
import getOnlineStoreExtension from './ws-online-store';
import getNavigationExtension from './ws-navigation';
import getMediaExtension from './ws-media';
import getImageExtension from './ws-image';
import getHtmlWidgetExtension from './ws-html-widget';
import getGalleryExtension from './ws-gallery';
import getLinkExtension from './ws-link';
import getContactFormExtension from './ws-contact-form';
import getTextFormattingExtension from './ws-text-formatting';
import getGoogleMapEmbedExtension from './ws-google-map-embed';
import getIconExtension from './ws-icon';
import getSliderExtension from './ws-slider';
import getContactInfoExtension from './ws-contact-info';
import getCompositeGroupExtension from './ws-composite-group';
import getColumnExtension from './ws-column';

const getAvailableExtensions = () => [
  getFooterNavigationExtension(),
  getSocialLinksExtension(),
  getOnlineStoreExtension(),
  getNavigationExtension(),
  getMediaExtension(),
  getImageExtension(),
  getHtmlWidgetExtension(),
  getGalleryExtension(),
  getLinkExtension(),
  getContactFormExtension(),
  getTextFormattingExtension(),
  getGoogleMapEmbedExtension(),
  getIconExtension(),
  getSliderExtension(),
  getContactInfoExtension(),
  getCompositeGroupExtension(),
  getColumnExtension(),
];

export default getAvailableExtensions;
